import { http, httpCore } from '@/http-common';
import cookies from 'vue-cookies';

const applicationToken = '928221a8-efd4-4bd1-aecc-b21767fbebd8';
const sessionId = cookies.get('SessionId');
class UserService {
  async post(user) {
    return http.post('/user', user, {
      headers: {
        Authorization: `${applicationToken}`,
      },
    });
  }

  async login(loginInputModel) {
    return http.post('/user/login', loginInputModel, {
      headers: {
        Authorization: `${applicationToken}`,
        Accept: '*/*',
      },
    });
  }

  async validSession() {
    return httpCore.get(`/user/session/valid/${sessionId}`, {
      headers: {
        Authorization: `${applicationToken}`,
        Accept: '*/*',
      },
    });
  }

  async forgot(passwordForgotInputModel) {
    return http.post('/user/password/forgot', passwordForgotInputModel, {
      headers: {
        Authorization: `${applicationToken}`,
      },
    });
  }

  async resetPassword(passwordResetInputModel) {
    return http.post('/user/password/reset', passwordResetInputModel, {
      headers: {
        Authorization: `${applicationToken}`,
      },
    });
  }

  async validPasswordReset(key) {
    return http.get(`/user/password/reset/verify/${encodeURIComponent(key)}`, {
      headers: {
        Authorization: `${applicationToken}`,
      },
    });
  }

  async getUserForMenu() {
    return http.get(`/session/${sessionId}`);
  }

  async removeSessionToken() {
    return http.delete(`/session/${sessionId}`);
  }

  async getUserProfile() {
    return http.get(`/profile/${sessionId}`);
  }

  async saveUserMyData(userForm) {
    return http.patch(`/profile/${sessionId}`, userForm);
  }

  async passwordChange(inputModel) {
    return http.post('/profile/password/change', inputModel);
  }

  async approvals() {
    return http.get('/profile/approvals');
  }

  async sendMailVerification() {
    return http.post('/profile/approval/email/send');
  }

  async verifyMailApproval(key, hashToken) {
    return httpCore.get(`/profile/approval/email/verify/${encodeURIComponent(key)}/${encodeURIComponent(hashToken)}`);
  }

  async gerarToken() {
    return http.post('/session/generate-token');
  }

  async getToken() {
    return http.get('/session/token');
  }
}

export default new UserService();
